/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/7/20
 * Time: 3:19 PM
 */
const api = {
  // common endpoints
  OAUTH: `oauth/token`,
  FORGOT_PASSWORD: `corporate/admin/password/forgot/reset`,
  FORGOT_PASSWORD_REQUEST: `corporate/admin/password/forgot/reset/request`,

  CHECK_MOBILE_EXIST: (mobile) => `mobile/user/check/mobile?mobile=${mobile}`,
  USER_SIGN_UP_SEND_OTP: `mobile/pin?appType=ios`,
  USER_SIGN_UP: (otp) => `mobile/pin/register/${otp}`,
  VERIFY_OTP : `mobile/pin/verify`,
  CHECK_EMAIL_EXIST:({email,emailType}) => `mobile/pin/check/email?email=${email}&emailType=${emailType}`,
  VERIFY_EMAIL: `mobile/pin/email/verify`,
  CHECK_BOTH_EMAIL_EXIST: `mobile/pin/check/both/email`,


  // corporate endpoints
  CORPORATE: `corporate`,
  CORPORATE_SELECT: (corporateId) => `corporate/${corporateId}`,

  CORPORATE_SYSTEM_USERS: `corporate/admin`,
  CORPORATE_SELECT_SYSTEM_USER: (corporateId) => `corporate/${corporateId}/admin`,
  CORPORATE_SYSTEM_USER_SELECT: (adminId) => `corporate/admin/${adminId}`,

  CORPORATE_WITH_BRANCHES: `corporate/withBranches`,

  CORPORATE_BRANCH: (corporateId) => `corporate/${corporateId}/branch`,
  CORPORATE_BRANCH_UPDATE: `corporate/branch`,
  CORPORATE_BRANCH_DELETE: (branchId) => `corporate/branch/${branchId}`,
  CORPORATE_DASHBOARD: (corporateId) => `dashboard/corporate/${corporateId}`,

  CORPORATE_BRANCH_BUILDING: ({corporateId, branchId}) => `corporate/${corporateId}/branch/${branchId}/building`,
  CORPORATE_BRANCH_BUILDING_DELETE: (buildingId) => `corporate/branch/building/${buildingId}`,
  CORPORATES_BRANCH_BUILDING: `corporate/branch/building`,

  CORPORATES_FLOOR: `/corporate/branch/building/floor`,
  CORPOARTE_FLOOR_DELETE: (floorId) => `corporate/branch/building/floor/${floorId}`,
  CORPOARTE_FLOOR_CREATE: ({corporateId, buildingId}) => `corporate/${corporateId}/branch/building/${buildingId}/floor`,

  CORPORATE_LOGIN_DETAILS: ({corporateId, startDate, endDate}) => `corporate/${corporateId}/corporate/logindetails?startDate=${startDate}&endDate=${endDate}`,

  CORPORATE_DEPARTMENT: (corporateId) => `corporate/${corporateId}/department`,
  CORPORATE_DEPARTMENT_DELETE: (departmentId) => `corporate/department/${departmentId}`,
  CORPORATES_DEPARTMENT: `corporate/department`,

  CORPORATE_SUCCESS_VISITOR_LOGS: ({corporateId, startDate, endDate}) => `corporate/${corporateId}/successvisitorlogs?startDate=${startDate}&endDate=${endDate}`,
  CORPORATE_FAILED_VISITOR_LOGS: ({corporateId, startDate, endDate}) => `corporate/${corporateId}/failvisitorlogs?startDate=${startDate}&endDate=${endDate}`,

  CORPORATE_INVOICE_REPORT: ({corporateId, startDate, endDate, branchId , checkInType}) => `report/corporate/${corporateId}/invoicereport?checkInType=${checkInType}&bid=${branchId}&startDate=${startDate}&endDate=${endDate}`,

  CORPORATE_USER: `corporate/user`,
  CORPORATE_USERS_BULK_UPLOAD: `corporate/bulk/user`,
  CORPORATE_SELECT_USER: (corporateId) => `corporate/${corporateId}/user`,
  CORPORATE_SELECT_USER_WITH_PAGINATION: ({corporateId,index,size,searchValue}) => `corporate/${corporateId}/user?index=${index}&size=${size}&searchValue=${searchValue}`,
  CORPORATE_SELECT_AZURE_USER: (corporateId) => `azure/users/${corporateId}`,

  CORPORATE_CARD: (corporateId) => `corporate/${corporateId}/card`,
  CORPORATE_CARD_CREATE: ({corporateId, branchId}) => `corporate/${corporateId}/branch/${branchId}/card`,
  CORPORATE_CARD_UPDATE: `corporate/branch/card`,
  CORPORATE_BULK_CARD_ADD: (corporateId) => `corporate/${corporateId}/card/bulkupload`,
  CORPORATE_CARD_CHANGE_STATE: ({cardId, status}) => `corporate/card/${cardId}/status/${status}`,
  CORPORATE_CARD_SELECT: (cardId) => `corporate/card/${cardId}`,

  CORPORATE_USER_CATEGORIZATION: (corporateId,categoryId) => `web/user/corporate/${corporateId}/category/${categoryId}`,

  CORPORATE_WIFI_PACKAGES: `corporate/wifiPackages`,
  CORPORATE_SELECT_WIFI_PACKAGES: (corporateId) => `corporate/${corporateId}/wifiPackages`,
  CORPORATE_WIFI_PACKAGE_SELECT: (wifiPackageId) => `corporate/wifiPackages/${wifiPackageId}`,

  CORPORATE_WIDGETS_FOR_VISITOR_REPORT: ({corporateId, startDate, endDate, branchId}) => `report/corporate/${corporateId}/branch/${branchId}/widgetsforvisitorsreport?startDate=${startDate}&endDate=${endDate}`,

  CORPORATE_INQUIRIES_GET_ALL: (corporateId) => `inquiries/corporate/${corporateId}/inquirie?option=0`,
  CORPORATE_INQUIRIES_SAVE_UPDATE: (corporateId) => `inquiries/corporate/${corporateId}/inquirie`,
  CORPORATE_INQUIRIES_STATUS_UPDATE: ({corporateId, inquireId}) => `inquiries/corporate/${corporateId}/inquirie/${inquireId}`,

  // receptionist endpoints
  CORPORATE_OFFLINE_BULK: (corporateId) => `bulkupload/corporate/${corporateId}/bulk`, // bulk upload

  CORPORATE_VISITOR_IDENTIFY_SEARCH: ({corporateId, identifyValue, searchType}) => searchType === undefined ? `corporate/${corporateId}/visitor/identify/${identifyValue}` : `corporate/${corporateId}/visitor/identify/${identifyValue}?searchType=${searchType}`,
  CORPORATE_VISITOR_IDENTIFY_UPDATED_SEARCH: ({corporateId, identifyValue, searchType}) => `corporate/${corporateId}/visitor/identify/${identifyValue}?searchType=${searchType}`,
  CORPORATE_VISITOR_MOBILE_SEARCH: ({corporateId, mobile}) => `corporate/${corporateId}/visitor/mobile/${mobile}`,
  CORPORATE_VISITOR_VERIFY: `corporate/visitor/verify`,
  CORPORATE_VISITOR_TAG_REMARK: (corporateId) => `corporate/${corporateId}/visitor/tag/remark`,

  CORPORATE_VISITORS_HISTORY: ({corporateId, startDate, endDate}) => `corporate/${corporateId}/visitors/history?startDate=${startDate}&endDate=${endDate}`,
  CORPORATE_VISITORS_CHECKOUT: `corporate/checkOut/visitors`,
  CORPORATE_VISITORS_OVERDUE_CHECKOUT: `corporate/checkOut/overdue/visitors`,
  CORPORATE_VISITORS_OVERDUE: (corporateId) => `corporate/${corporateId}/visitors/overdue`,
  CORPORATE_VISITORS_CHECKIN: (corporateId) => `corporate/${corporateId}/visitors/checkIn`,
  CORPORATE_VISITORS_COUNT: (corporateId) => `corporate/${corporateId}/branch/visitor/count`,
  CORPORATE_ALL_VISITORS_COUNT: (corporateId) => `corporate/${corporateId}/visitors/count`,
  CORPORATE_VISITORS_COUNT_BY_DATE: ({corporateId, date}) => `corporate/${corporateId}/branch/visitor/count/bydate?date=${date}`,
  CORPORATE_VISITORS_COUNT_IN_BUILDING: ({corporateId, buildingId}) => `corporate/${corporateId}/branch/building/${buildingId}/visitor/count`,
  CORPORATE_VISITORS_COUNT_IN_BUILDING_BY_DATE: ({corporateId, buildingId, date}) => `corporate/${corporateId}/branch/building/${buildingId}/visitor/count/bydate?date=${date}`,

  CORPORATE_PRESHEDULED_MEETING_CREATE: ({corporateId, refId}) => `corporate/${corporateId}/meeting/preScheduled?refId=${refId}`,
  CORPORATE_MEETING_CREATE: (corporateId) => `corporate/${corporateId}/meeting`, // create a meeting
  CORPORATE_HOST_SEARCH: ({corporateId, searchValue}) => `corporate/${corporateId}/host/${searchValue}`, // search host using name, mobile ..

  CORPORATE_AVAILABLE_CARD_IN_FLOOR: (floorId) => `corporate/branch/building/floor/${floorId}/card/available`,
  CORPORATE_ACTIVE_CARD: (corporateId) => `corporate/${corporateId}/branch/card/active`,

  CORPORATE_FORWARD_MEETING: `corporate/meeting/forward`,
  USER: `user`,
  DELETE_USER: (userId) => `user/delete/${userId}`,
  GET_ALL_DELETE_REQUESTS_USERS: ({status,index,size,searchValue}) => `user/view/delete/requests/${status}?index=${index}&size=${size}&searchValue=${searchValue}`,
  APPROVE_OR_REJECT_DELETE_REQUEST: (status) =>`user/change/delete/request-status/${status}`,

  CORPORATE_BUILDINGS: (coperateId) => `corporate/${coperateId}/buildings`,
  COMPANIES: `company`,
  SERVICES: `corporate/services`,

  //user groups
  CORPORATE_USER_GROUPS: (coperateId, size) => `user/group/corporate/${coperateId}`,
  CORPORATE_USER_GROUP_USER_NOT_IN_GROUP: (groupId) => `user/usersByNotInGroup/${groupId}`,
  CORPORATE_USER_GROUP_USERS: (groupId, size, page) => `user/group/${groupId}?size=${size}&page=${page}`,
  CORPORATE_ADD_USERS_TO_USER_GROUP: (groupId) => `user/group/${groupId}`,
  DELETE_GROUP_USER: (groupId, userId) => `user/group/${groupId}/${userId}`,
  UPDATE_CORPORATE_USER_GROUP: `user/group`,

  // super admin endpoints
  SUPER_DASHBOARD: `dashboard/super`,
  MEETING_REPORT: ({corporateId, branchId, buildingId, floorId, visitorIdentity, startDate, endDate}) => `report/meeting?startDate=${startDate}&endDate=${endDate}&corporateId=${corporateId}&branchId=${branchId}&buildingId=${buildingId}&floorId=${floorId}&visitorIdentity=${visitorIdentity}`,
  MEETING_VISITOR_REPORT: (meetingId) => `report/meeting/${meetingId}/visitor`,
  SYSTEM_ADMIN: `system/admin`,
  SYSTEM_ADMIN_DELETE: (adminId) => `system/admin/${adminId}`,

  SMS_REPORT: ({corporateId, serviceId, startDate, endDate}) => `report/sms/category/count?startDate=${startDate}&endDate=${endDate}&serviceId=${serviceId}&corporateId=${corporateId}`,
  SMS_REPORT_CATEGORY_FILTER: ({corporateId, categoryId, serviceId, startDate, endDate}) => `report/sms/category/${categoryId}?startDate=${startDate}&endDate=${endDate}&serviceId=${serviceId}&corporateId=${corporateId}`,

  // public users
  GET_PUBLIC_USERS: `user/all/PUBLIC`,
  UPDATE_PUBLIC_USERS: `user/update`,
  GET_PUBLIC_USERS_WITH_PAGINATION: ({index, size}) => `user/all/pagination/PUBLIC?index=${index}&size=${size}`,
  SEARCH_PUBLIC_USERS_WITH_PAGINATION: ({index, size, searchValue}) => `user/all/searchPage/PUBLIC?index=${index}&size=${size}&searchValue=${searchValue}`,

  // for iVCA
  IVCA_CORPORATE_BRANCH_CAMERA: ({corporateId, branchId}) => `corporate/${corporateId}/branch/${branchId}/camera`,
  IVCA_GET_ALL_CORPORATE_BRANCH_CAMERAS_BY_BRANCH: ({corporateId, branchId}) => `corporate/${corporateId}/branch/${branchId}/camera`,
  IVCA_RECOGNIZE_USER_BY_IMAGE: (corporateId) => `user/recognize/image/${corporateId}`,
  // --

  // host endpoints
  HOST_CHECK: ({mobile}) => `/mobile/user/authenticate/${mobile}`,
  HOST_OTP_SEND: ({mobile}) => `/mobile/user/sendAuth/${mobile}`,
  HOST_OTP_VERIFY: ({mobile}) => `/mobile/user/validate/${mobile}`,
  HOST_SCHEDULE_MEETING: ({corporateId}) => `/corporate/${corporateId}/meeting/schedule`,
  HOST_UPDATE_MEETING: ({corporateId}) => `/corporate/${corporateId}/meeting/update`,
  HOST_ALL_MEETING: ({corporateId, startDate, endDate}) => `/corporate/${corporateId}/meetings?startDate=${startDate}&endDate=${endDate}`,
  HOST_DELETE_MEETING: ({corporateId, refNo}) => `/corporate/${corporateId}/meeting/cancel?refNo=${refNo}`,
  HOST_BULK_VISITORS_SCHEDULE_MEETING: ({corporateId}) => `/corporate/${corporateId}/meeting/schedule/bulkUpload`,



  // event-tag
  //organizer
  CHECKIN_PARTICIPANTS:({corporateId})=> `/web/participant/corporate/${corporateId}/attendance`,
  GET_CHECKED_PARTICIPANTS : ({sub_event_id, corporateId}) => `web/participant/corporate/${corporateId}/attendance/subevent/${sub_event_id}`,
  GET_ALL_QUESTIONS : ({session_id,corporateId}) => `/web/participant/corporate/${corporateId}/allQuestion/session/${session_id}`,
  APPROVE_REJECT_QUESTIONS : ({participant_question_id, status,corporateId}) => `/web/participant/corporate/${corporateId}/question/${participant_question_id}/questionstatus/${status}`,
  GET_ALL_UNCHECKED_PARTICIPANTS : ({sub_event_id,corporateId}) => `/web/participant/corporate/${corporateId}/subevent/${sub_event_id}`,
  OPEN_QUESTION : ({question_id, corporateId}) => `web/participant/corporate/${corporateId}/select/${question_id}`,
  GET_CURRENT_OPEN_QUESTION : `web/participant/question`,
  CHECKIN_PUBLIC_USERS: ({uuid,userId}) => `mobile/subEvent/checkIn?uuid=${uuid}&user_id=${userId}`,

  //event
  EVENT_CATOGARIES: `/web/category`,
  CORPORATE_EVENTS: ({corporateId}) => `/web/event/corporate/${corporateId}`,
  CORPORATE_PUBLISHED_EVENTS: ({corporateId, startDate, endDate}) => `/web/event/corporate/${corporateId}/published?start_date=${startDate}&end_date=${endDate}`,
  CORPORATE_UNPUBLISH_EVENTS: ({corporateId}) => `/web/event/corporate/${corporateId}/unpublished`,
  CORPORATE_DRAFT_EVENTS: ({corporateId}) => `/web/event/corporate/${corporateId}/draft`,
  CREATE_CORPORATE_EVENTS: ({corporateId}) => `/web/event/corporate/${corporateId}`, // changed
  UPDATE_CORPORATE_EVENT: ({corporateId}) => `/web/event/corporate/${corporateId}`, // changed
  SEND_BROCHURE_FILES: ({corporateId}) => `/web/file/corporate/${corporateId}/brochure`, //changed
  SEND_ATTACHMENT_FILES: ({corporateId}) => `/web/file/corporate/${corporateId}/attachment`, //changed
  GET_A_CORPORATE_EVENT: ({eventId}) => `/web/event​/view/${eventId}`,
  DELETE_CORPORATE_EVENT: ({eventId, corporateId}) =>`/web/event/${eventId}/corporate/${corporateId}`,

  GET_EVENT_DASHBOARD_DATA: ({corporateId}) => `/web/dashboard/corporate/${corporateId}`,

  SEND_EVENT_INVITATION: ({corporateId}) =>`/web/participant/corporate/${corporateId}/invite`,
  GET_RECENT_EVENT_PARTICIPATION: (userId) => `web/user/participationDetails/preview/${userId}`,
  DUPLICATE_CORPORATE_EVENT: ({eventId, corporateId}) =>`/web/event/corporate/${corporateId}/duplicate/${eventId}`,
  GET_EVENT_QUICKSIGHT_DATA: (corporateId) => `/web/dashboard/quicksight/${corporateId}`, // quicksight API

  // event -> sub-event questions
  SAVE_SUB_EVENT_PARTICIPANT_QUESTION: (corporateId) => `/web/subEvent/corporate/${corporateId}/participantQuestion`,
  DELETE_SUB_EVENT_PARTICIPANT_QUESTION: (corporateId, questionId) => `/web/subEvent/corporate/${corporateId}/participantQuestion/${questionId}`,
  DELETE_SUB_EVENT_PARTICIPANT_QUESTION_ANSWER: (corporateId, questionId, answerId) => `/web/subEvent/corporate/${corporateId}/participantQuestion/${questionId}/answer/${answerId}`,
  UPDATE_QUESTION_PRIORITY_LEVEL: (corporateId) => `/web/subEvent/corporate/${corporateId}/participantQuestion/updateQuestionOrder`,
  GET_SUB_EVENT_QUESTIONS: (corporateId, subEventId) => `web/subEvent/corporate/${corporateId}/participantQuestion/${subEventId}`,

  // eventtags - mobile
  GET_MOBILE_EVENTS: `mobile/event/upcoming/token?index=0&size=10`,
  GET_STATIC_EVENT_DETAILS: `mobile/event/197`, // hard code event -> Please remove this after the DEMO //197 - //36
  REGISTER_SUB_EVENT: ({eventId, userId}) => `mobile/subEvent/register/${eventId}?user_id=${userId}`, //179 - //61

  //eventtags - web
  GET_DYNAMIC_EVENT_DETAILS: (uuid) => `web/subEvent/find/uuid/${uuid}`,
  GET_UPCOMING_EVENTS: `mobile/event/upcoming/token?index=0&size=1000`,

  //notifications
  SEND_NOTIFICATION: ({corporateId}) => `/web/participant/corporate/${corporateId}/notification`,
  SEND_SINGLE_NOTIFICATION: ({corporateId, userId}) => `/web/notification/corporate/${corporateId}/user/${userId}`,
  SEND_CATEGORY_NOTIFICATION: ({corporateId}) => `/web/notification/corporate/${corporateId}/category`,
  DISPLAY_NOTIFICATIONS: ({sub_event_id, corporateId}) => `web/participant/corporate/${corporateId}/subevent/${sub_event_id}/notifications`,

  // sub event
  CREATE_SUB_EVENT: ({eventId, corporateId}) => `/web/subEvent/corporate/${corporateId}/add/${eventId}`, //changed
  GET_ALL_SUB_EVENT: ({event_id, corporateId}) => `/web/subEvent/corporate/${corporateId}/view/${event_id}`, //changed
  DELETE_SUB_EVENT: ({subEventId, corporateId}) => `/web/subEvent/delete/${subEventId}/corporate/${corporateId}`, //changed
  UPDATE_SUB_EVENT: ({corporateId}) => `/web/subEvent/corporate/${corporateId}`, //changed
  CHANGE_SUB_EVENT_STATUS: ({corporateId, subEventId}) => `/web/subEvent/corporate/${corporateId}/subevent/${subEventId}`,
  //$#$#
  GET_ONLINE_EVENT_URL: ({subeventId, corporateId}) => `/web/subEvent/corporate/${corporateId}/hostUrl/${subeventId}`, //changed

  // sessions
  CREATE_SESSION: ({sub_event_id, corporateId}) =>`web/session/corporate/${corporateId}/subevent/${sub_event_id}`, //changed
  DELETE_SESSION: ({sessionId, corporateId}) =>`web/session/${sessionId}/corporate/${corporateId}`, //changed
  GET_SUB_EVENT_SESSIONS: ({sub_event_id,corporateId}) =>`/web/session/corporate/${corporateId}/view/${sub_event_id}`, //changed
  GET_SESSION_SPEAKER_LIST: ({session_id, corporateId}) =>`/web/session/corporate/${corporateId}/speaker/session/${session_id}`, //changed but not use yet
  // SEARCH_SPEAKER: ({corporateId}) => `/web/speaker/linkedin/corporate/${corporateId}`, //changed
  SEARCH_SPEAKER: ({searchValue}) => `web/speaker/find/${searchValue}`,

  //feedback quetion
  MANAGE_FEED_BACK_QUESTION: ({corporateId}) => `/web/subEvent/corporate/${corporateId}/eventQuestion`, //changed
  MANAGE_GET_DELETE_FEED_BACK_QUESTION: ({id, corporateId}) => `/web/subEvent/corporate/${corporateId}/eventQuestion/${id}`, //changed
  GET_FEEDBACK_QUESTION_RATES :  ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/feedback/base/rate`, //change
  GET_OVERALL_SUBEVENT_FEEDBACKS : ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/feedback/base/participant`, //changed
  GET_ALL_SPEAKER_FEEDBACKS : ({session_id, speaker_profile_id, corporateId}) => `/web/subEvent/corporate/${corporateId}/session/${session_id}/feedback/speaker/${speaker_profile_id}`, //changed

  //participant
  MANAGE_INVITATION_MAIL: ({corporateId}) =>`/web/subEvent/corporate/${corporateId}/invitation/mail`,
  GET_INVITATION_MAIL: ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/invitation/mail`, // changed
  GET_SUBEVENT: ({event_id, corporateId}) => `web/subEvent/corporate/${corporateId}/view/${event_id}`,
  GET_PARTICIPANT_ON_SUBEVENT: ({sub_event_id}) => `/web/participant/${sub_event_id} `,
  VIEW_PARTICIPANTS_ON_STATUS:({sub_event_id,status,corporateId}) => `/web/participant/corporate/${corporateId}/public/subevent/${sub_event_id}/status/${status}`,
  APPROVE_REJECT_PARTICIPANTS: ({participant_id, corporateId, status}) => `web/participant/${participant_id}/corporate/${corporateId}/status/${status}`,

  //SPONSOR
  SEND_SPONSOR_CATEGORY : ({corporateId}) => `/web/subEvent/corporate/${corporateId}/sponsor/category`,//changed
  SEND_SPONSOR :({event_id, corporateId}) => `/web/subEvent/corporate/${corporateId}/sponsor/name/event/${event_id}`, // changed - conflit
  GET_ALL_SPONSOR_NAMES :({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/sponsor/name`,//changed
  GET_ALL_SPONSORSHIP_CATEGORY : ({corporateId}) => `/web/subEvent/corporate/${corporateId}/sponsor/category `,
  GET_SELECTED_SPONSOR_DETAILS : ({sub_event_id, sponsor_id, sponsor_category_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/sponsor/sponsor_id/${sponsor_id}/sponsor_category/${sponsor_category_id}`, //changed - conflit
  // DELETE_SPONSOR_DETAILS :   ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/sponsor`,
  DELETE_SPONSOR_DETAILS :   ({sub_event_cat_id, corporateId}) => `/web/subEvent/corporate/${corporateId}/sponsor/${sub_event_cat_id}`,
  LOAD_ALL_SPONSOR_DETAILS : ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/sponsor/`,

  //VOLUNTEERS
  ADD_VOLUNTEERS_TO_THE_SUB_EVENT : ({sub_event_id, corporateId}) => `/web/subEvent/${sub_event_id}/corporate/${corporateId}/add/usher`,
  GET_SUB_EVENT_VOLUNTEERS : ({event_id, corporateId}) => `/web/subEvent/${event_id}/corporate/${corporateId}/usher`,
  GET_ALL_SYSTEM_VOLUNTEERS : (corporate_id) => `/usher/corporate/${corporate_id}`,

// -----------------------------------------------------------------------------------------------------------------------------------------------

  //GUEST
  GUEST_USER_CHECK_MOBILE_NUMBER_EXIST: (mobile,pinRequired) => `mobile/user/exist?mobile=${mobile}&pinRequired=${pinRequired}`,
  GUEST_USER_SEND_OTP: `mobile/pin`,
  SEND_OTP_TO_BOTH_EMAILS: `mobile/pin/emails/send`,
  GUEST_USER_REGISTRATION: `mobile/user/register`,
  GUEST_GET_ALL_BUILDING_BY_BRANCH: (branchId) => `corporate/branch/${branchId}/buildings`,
  GUEST_GET_BRANCH_NAME_BY_ID: (branchId) => `corporate/branch/${branchId}`,
  GUEST_USER_CHECK_IN: `corporate/branch/floor/checkIn`,
  GUEST_VIEW_USER_PROFILE: `mobile/user/profile`,
  GUEST_UPDATE_USER_PROFILE: (userId) => `mobile/user/profile/update/${userId}`,

  //PUBLIC (Add new corporate)
  TEMP_CORPORATE: `tempcorporate`,
  TEMP_CORPORATE_APPROVE_OR_REJECT: `tempcorporate/action`,

  //QR checkin
  CORPORATE_BRANCH_QR_CHECKIN_VISITORS_HISTORY: ({corporateId, branchId, startDate, endDate}) => `corporate/${corporateId}/branch/visitors/history?branchId=${branchId}&startDate=${startDate}&endDate=${endDate}`,

  /*
   * VISITORTAGS + PARKTAGS
   */

  // Change Visitor Vehicle Number
  VISITOR_VEHICLE_NUMBER_UPDATE: `user/vehicle`,
  GET_RECENT_MEETINGS: (userId) => `user/meetingDetails/preview/${userId}`,

  // parktags
  GET_RECENT_PARKING_TRANSACTIONS: (userId, isPublic) => isPublic ? `parking-details/preview/public/user/${userId}` : `parking-details/preview/corporate/user/${userId}`,
  REMOVE_CORPORATE_PROFILE: (userId) => `mobile/user/corporate/${userId}`,


  //SpaceTags
  ST_CREATE_WORKSPACE: ({ corporateId })=> `workspace/corporate/${corporateId}`,
  ST_WORKSPACE_FILTER: ({ corporateId })=> `workspace/corporate/${corporateId}/filter`,
  ST_REMOVE_WORKSPACE: ({workspaceId, corporateId}) => `workspace/${workspaceId}/corporate/${corporateId}`,
  ST_GET_RESERVATION_DATA_OF_WORKSPACE: ({workspaceId, corporateId, startDate, endDate}) => `reservation/corporate/${corporateId}/workSpace/${workspaceId}?startDate=${startDate}&endDate=${endDate}`,
  //SpaceTags Notifications
  ST_SEND_PUSH_NOTIFICATION: ({ corporateId })=> `notification/corporate/${corporateId}`,
  ST_GET_NOTIFICATION_HISTORY: ({ corporateId })=> `notification/corporate/${corporateId}/filter`
};

export default api;
